import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { GlobalFocusToggle } from '@els/els-react--utils';
import HeaderComponentContainer from '@Containers/Header/HeaderComponentContainer';
import Footer from '@Components/Footer';
import ContentClickManager from '@Components/ContentClickManager';

import './Page.scss';

export default function Page(props) {
  const { id, withSubTabs, withHeader, headerType, withFooter, pageClassName, className, children } = props;

  return (
    <ContentClickManager>
      <GlobalFocusToggle>
        {withHeader && <HeaderComponentContainer type={headerType} />}
        <section id={id} className={classnames([pageClassName, 'react-page'])}>
          <section
            className={classnames('react-page--children-wrapper', className, {
              'react-page--sub-tabs-padding': withSubTabs,
            })}>
            {children}
          </section>
          {withFooter && <Footer className="react-page-footer" />}
        </section>
      </GlobalFocusToggle>
    </ContentClickManager>
  );
}

Page.defaultProps = {
  withHeader: false,
  withFooter: true,
  withSubTabs: false,
};

Page.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  withHeader: PropTypes.bool,
  headerType: PropTypes.string,
  withFooter: PropTypes.bool,
  withSubTabs: PropTypes.bool,
  pageClassName: PropTypes.string,
  children: PropTypes.node,
};
